import styled from "styled-components";
import React from "react";

import temperatureLineIcon from "../../../../assets/images/weather_icon/temperature_line.png";
import windspeedLineIcon from "../../../../assets/images/weather_icon/windspeed_line.png";
import precipitationLineIcon from "../../../../assets/images/weather_icon/precipitation_line.png";
import humidityLineIcon from "../../../../assets/images/weather_icon/humidity_line.png";
import windspeedLineLightIcon from "../../../../assets/images/weather_icon/windspeed_line_light.png";
import precipitationLineLightIcon from "../../../../assets/images/weather_icon/precipitation_line_light.png";
import humidityLineLightIcon from "../../../../assets/images/weather_icon/humidity_line_light.png";

import s30Icon from "../../../../assets/images/New_weather_icon/S30_W.png";
import s10Icon from "../../../../assets/images/New_weather_icon/S10_W.png";
import s40Icon from "../../../../assets/images/New_weather_icon/S40_W.png";
import s44Icon from "../../../../assets/images/New_weather_icon/S44_W.png";
import s45Icon from "../../../../assets/images/New_weather_icon/S45_W.png";
import s46Icon from "../../../../assets/images/New_weather_icon/S46_W.png";
import s47Icon from "../../../../assets/images/New_weather_icon/S47_W.png";
import s11Icon from "../../../../assets/images/New_weather_icon/S11_W.png";
import s12Icon from "../../../../assets/images/New_weather_icon/S12_W.png";
import s13Icon from "../../../../assets/images/New_weather_icon/S13_W.png";
import s14Icon from "../../../../assets/images/New_weather_icon/S14_W.png";
import s15Icon from "../../../../assets/images/New_weather_icon/S15_W.png";
import s16Icon from "../../../../assets/images/New_weather_icon/S16_W.png";
import s17Icon from "../../../../assets/images/New_weather_icon/S17_W.png";
import s31Icon from "../../../../assets/images/New_weather_icon/S31_W.png";
import s32Icon from "../../../../assets/images/New_weather_icon/S32_W.png";
import s33Icon from "../../../../assets/images/New_weather_icon/S33_W.png";
import s34Icon from "../../../../assets/images/New_weather_icon/S34_W.png";
import s35Icon from "../../../../assets/images/New_weather_icon/S35_W.png";
import s36Icon from "../../../../assets/images/New_weather_icon/S36_W.png";
import s37Icon from "../../../../assets/images/New_weather_icon/S37_W.png";
import s41Icon from "../../../../assets/images/New_weather_icon/S41_W.png";
import s42Icon from "../../../../assets/images/New_weather_icon/S42_W.png";
import s43Icon from "../../../../assets/images/New_weather_icon/S43_W.png";

const weatherIcons = {
    S10: s10Icon,
    S11: s11Icon,
    S12: s12Icon,
    S13: s13Icon,
    S14: s14Icon,
    S15: s15Icon,
    S16: s16Icon,
    S17: s17Icon,
    S30: s30Icon,
    S31: s31Icon,
    S32: s32Icon,
    S33: s33Icon,
    S34: s34Icon,
    S35: s35Icon,
    S36: s36Icon,
    S37: s37Icon,
    S40: s40Icon,
    S41: s41Icon,
    S42: s42Icon,
    S43: s43Icon,
    S44: s44Icon,
    S45: s45Icon,
    S46: s46Icon,
    S47: s47Icon,
    '01d': s10Icon,
    '01n': s10Icon,
    '02d': s30Icon,
    '02n': s30Icon,
    '03d': s40Icon,
    '03n': s40Icon,
    '04d': s40Icon,
    '04n': s40Icon,
    '09d': s41Icon,
    '09n': s41Icon,
    '10d': s31Icon,
    '10n': s31Icon,
    '11d': s40Icon,
    '11n': s40Icon,
    '13d': s43Icon,
    '13n': s43Icon,
    '50d': s40Icon,
    '50n': s40Icon,
  };
  
const getWeatherIconImage = (iconCode) => {
    return weatherIcons[iconCode] || s10Icon;
};

const getWeatherThemeIcon = (iconType, themeMode = "dark") => {
const weatherIcons = {
    dark: {
    windspeed: windspeedLineIcon,
    precipitation: precipitationLineIcon,
    humidity: humidityLineIcon,
    },
    light: {
    windspeed: windspeedLineLightIcon,
    precipitation: precipitationLineLightIcon,
    humidity: humidityLineLightIcon,
    },
};

const theme = weatherIcons[themeMode] || weatherIcons.dark;
    return theme[iconType] || weatherIcons.dark[iconType];
};

// 테마별 컬러 매핑 객체
const themeColors = {
    dark: {
      mainColor: "white",
      MainContainerBackgroundLinearGradient01: "rgba(0, 0, 0, 0.4)",
      MainContainerBackgroundLinearGradient02: "rgba(0, 0, 0, 0.4)",
      MainPanelBackgroundLinearGradient01: "rgba(0, 0, 0, 0.3)",
      MainPanelBackgroundLinearGradient02: "rgba(0, 0, 0, 0.5)",
      MainPanelBackgroundLinearGradient03: "rgba(0, 0, 0, 0.3)",
      MainPanelOutline: "rgba(255, 255, 255, 0.4)",
      WeatherPanelBackgroundLinearGradient01: "rgba(0, 0, 0, 0.3)",
      WeatherPanelBackgroundLinearGradient02: "rgba(0, 0, 0, 0.5)",
      WeatherPanelBackgroundLinearGradient03: "rgba(0, 0, 0, 0.3)",
      WeatherPanelOutline: "rgba(255, 255, 255, 0.4)",
      WeatherLabelColor: "rgba(255, 255, 255, 0.6)",
      bottomMessageBackground: "rgba(255, 255, 255, 0.2)",
    },
    light: {
      mainColor: "black",
      MainContainerBackgroundLinearGradient01: "rgba(255, 255, 255, 0.4)",
      MainContainerBackgroundLinearGradient02: "rgba(255, 255, 255, 0.4)",
      MainPanelBackgroundLinearGradient01: "rgba(255, 255, 255, 0.3)",
      MainPanelBackgroundLinearGradient02: "rgba(255, 255, 255, 0.5)",
      MainPanelBackgroundLinearGradient03: "rgba(255, 255, 255, 0.3)",
      MainPanelOutline: "rgba(255, 255, 255, 0.4)",
      WeatherPanelBackgroundLinearGradient01: "rgba(255, 255, 255, 0.3)",
      WeatherPanelBackgroundLinearGradient02: "rgba(255, 255, 255, 0.5)",
      WeatherPanelBackgroundLinearGradient03: "rgba(255, 255, 255, 0.3)",
      MainPanelOutline: "rgba(255, 255, 255, 0.4)",
      WeatherLabelColor: "rgba(0, 0, 0, 0.6)",
      bottomMessageBackground: "rgba(0, 0, 0, 0.2)",
    },
  };

/**
 * 테마모드에 따른 색상을 가져오는 함수
 * @param {string} colorName - 색상 이름 (예: "mainColor", "MainPanelOutline")
 * @param {string} themeMode - 테마 모드 ("dark" 또는 "light")
 * @returns {string} 해당 테마의 색상 값
 */
const getThemeColor = (colorName, themeMode = "dark") => {
    const theme = themeColors[themeMode] || themeColors.dark;
    return theme[colorName] || themeColors.dark[colorName];
};

// 날씨 패널 컴포넌트 ####################################################################
const MoleculeWeatherPanel = ({
    orientation,
    themeMode,
    weatherData,
}) => {
    const getWeatherStatus = (weather) => {
        switch (weather) {
          case "1": return "맑음";
          case "3": return "구름 많음";
          case "4": return "흐림";
          case "Clear": return "맑음";
          case "Clouds": return "구름 많음";
          case "Rain": return "비";
          case "Drizzle": return "이슬비";
          case "Thunderstorm": return "뇌우";
          case "Snow": return "눈";
          case "Mist":
          case "Fog": return "안개";
          default:
            if (typeof weather === "string") {
              return weather;
            }
            return "-";
        }
      };
    
      const getWeatherIconCode = (skyCode, ptyCode) => {
        return `S${skyCode}${ptyCode}`;
      };
    
      const currentWeatherIcon = weatherData.sky && weatherData.pty ? 
        getWeatherIconCode(
          weatherData.sky,
          weatherData.pty
        ) : weatherData.weatherIcon;
    
    return (
        <WeatherPanel orientation={orientation} themeMode={themeMode}>
        <NewWeatherContentWrapper orientation={orientation}>
          <MainWeatherGroup orientation={orientation}>
            <MainWeatherIconBlock orientation={orientation}>
              <MainWeatherIcon
                orientation={orientation}
                src={getWeatherIconImage(currentWeatherIcon)}
                alt={weatherData.weather_icon}
              />
              <WeatherStatus orientation={orientation} themeMode={themeMode}>
                {weatherData.weatherMain}
              </WeatherStatus>
            </MainWeatherIconBlock>
            <MainWeatherInfoBlock>
              <MainTemperatureContainer orientation={orientation}>
                <MainTemperatureNumber orientation={orientation} themeMode={themeMode}>
                  {weatherData.temperature}
                </MainTemperatureNumber>
                <MainTemperatureUnit orientation={orientation} themeMode={themeMode}>
                  °C
                </MainTemperatureUnit>
              </MainTemperatureContainer>
            </MainWeatherInfoBlock>
            <MinMaxTemperatureContainer orientation={orientation}>
              <MinMaxTemperature orientation={orientation} themeMode={themeMode}>
                최저 {weatherData.minTemperature}°
              </MinMaxTemperature>
              {orientation === "portrait" && <VerticalDivider2 themeMode={themeMode} />}
              <MinMaxTemperature orientation={orientation} themeMode={themeMode}>
                최고 {weatherData.maxTemperature}°
              </MinMaxTemperature>
            </MinMaxTemperatureContainer>
          </MainWeatherGroup>
          {orientation === "landscape" && <div style={{ width: "10px", height: "100%" }} />}

          <WeatherDataGroup orientation={orientation}>
            <WeatherDataItem orientation={orientation}>
              <WeatherDataIconContainer orientation={orientation}>
                <WeatherIconContainer orientation={orientation}>
                  <WeatherIcon
                    orientation={orientation}
                    src={getWeatherThemeIcon("windspeed", themeMode)}
                    alt="풍속"
                  />
                </WeatherIconContainer>
                <WeatherLabel orientation={orientation} themeMode={themeMode}>풍속</WeatherLabel>
              </WeatherDataIconContainer>
              <WeatherDataValueContainer orientation={orientation}>
                <WeatherValueNumber orientation={orientation} themeMode={themeMode}>
                  {weatherData.wind}
                </WeatherValueNumber>
                <WeatherValueUnit orientation={orientation} themeMode={themeMode}>m/s</WeatherValueUnit>
              </WeatherDataValueContainer>
            </WeatherDataItem>

            {orientation === "portrait" && <VerticalDivider themeMode={themeMode} />}

            <WeatherDataItem orientation={orientation}>
              <WeatherDataIconContainer orientation={orientation}>
                <WeatherIconContainer orientation={orientation}>
                  <WeatherIcon
                    orientation={orientation}
                    src={getWeatherThemeIcon("precipitation", themeMode)}
                    alt="강수량"
                  />
                </WeatherIconContainer>
                <WeatherLabel orientation={orientation} themeMode={themeMode}>강수량</WeatherLabel>
              </WeatherDataIconContainer>
              <WeatherDataValueContainer orientation={orientation}>
                <WeatherValueNumber orientation={orientation} themeMode={themeMode}>
                  {weatherData.precipitation}
                </WeatherValueNumber>
                <WeatherValueUnit orientation={orientation} themeMode={themeMode}>
                  mm/h
                </WeatherValueUnit>
              </WeatherDataValueContainer>
            </WeatherDataItem>

            {orientation === "portrait" && <VerticalDivider themeMode={themeMode} />}

            <WeatherDataItem orientation={orientation}>
              <WeatherDataIconContainer orientation={orientation}>
                <WeatherIconContainer orientation={orientation}>
                  <WeatherIcon
                    orientation={orientation}
                    src={getWeatherThemeIcon("humidity", themeMode)}
                    alt="습도"
                  />
                </WeatherIconContainer>
                <WeatherLabel orientation={orientation} themeMode={themeMode}>습도</WeatherLabel>
              </WeatherDataIconContainer>
              <WeatherDataValueContainer orientation={orientation}>
                <WeatherValueNumber orientation={orientation} themeMode={themeMode}>
                  {weatherData.humidity}
                </WeatherValueNumber>
                <WeatherValueUnit orientation={orientation} themeMode={themeMode}>%</WeatherValueUnit>
              </WeatherDataValueContainer>
            </WeatherDataItem>
          </WeatherDataGroup>
        </NewWeatherContentWrapper>
      </WeatherPanel>
      );
}

export default MoleculeWeatherPanel;

const WeatherPanel = styled.div`
  flex: 1;
  width: 952px;
  display: flex;
  flex-direction: column;
  /* background: linear-gradient(
    136deg,
    ${({ themeMode }) =>
        getThemeColor("WeatherPanelBackgroundLinearGradient01", themeMode)}
      0%,
    ${({ themeMode }) =>
        getThemeColor("WeatherPanelBackgroundLinearGradient02", themeMode)}
      50%,
    ${({ themeMode }) =>
        getThemeColor("WeatherPanelBackgroundLinearGradient03", themeMode)}
      100%
  ); */
  /* border-radius: 20px; */
  /* margin: 10px; */
  /* outline: 3px
    ${({ themeMode }) => getThemeColor("WeatherPanelOutline", themeMode)} solid; */
  /* outline-offset: -3px; */
  /* backdrop-filter: blur(12px); */
  /* padding: 60px; */
  min-height: 0;
  overflow: hidden;
  justify-content: center;

  flex-shrink: 1;

  ${({ orientation }) =>
    orientation === "portrait" &&
    `
    /* border-radius: 20px; */
    /* margin: 5px; */
    /* padding: 15px; */
    margin: 12px 30px 12px 30px;
  `}
`;

const NewWeatherContentWrapper = styled.div`
  display: flex;
  flex-direction: row;
  flex: 1;

  ${({ orientation }) =>
    orientation === "landscape"
      ? `
    gap: 30px;
    justify-content: space-around;
  `
      : `
    flex-direction: column;
    gap: 4px;
    justify-content: flex-start;
  `}

  align-items: center;
  width: 100%;
  min-height: 0;
  flex-shrink: 1;
`;

const MainWeatherGroup = styled.div`
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: flex-start;
  gap: 30px;

  ${({ orientation }) =>
    orientation === "portrait" &&
    `
    width: 100%;
    justify-content: space-between;
    gap: 0;
  `}
`;

const MainWeatherIconBlock = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;

  ${({ orientation }) =>
    orientation === "portrait" &&
    `
    flex-direction: row;
    gap: 32px;
    align-items: center;
  `}
`;

const MainWeatherInfoBlock = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  gap: 4px;
`;

const WeatherDataGroup = styled.div`
  ${({ orientation }) =>
    orientation === "landscape"
      ? `
    display: contents;
  `
      : `
    display: flex;
    flex-direction: row;
    width: 100%;
    justify-content: space-between;
    align-items: center;
    padding-bottom: 8px;
  `}
`;

const MainWeatherIcon = styled.img`
  width: 160px;
  height: 160px;
  @media (max-width: 900px) {
    width: 100px;
    height: 100px;
  }

  ${({ orientation }) =>
    orientation === "portrait" &&
    `
    width: 120px;
    height: 120px;
  `}
`;

const WeatherInfoContainer = styled.div`
  display: flex;
  flex-direction: column;
  gap: 8px;

  ${({ orientation }) =>
    orientation === "portrait" &&
    `
    flex-direction: row;
    gap: 20px;
    align-items: center;
    justify-content: center;
  `}
`;

const WeatherStatus = styled.div`
  color: ${({ themeMode }) =>
    getThemeColor("mainColor", themeMode)};
  font-size: 2.8rem;
  font-family: Pretendard;
  font-weight: 600;
  text-align: center;

  ${({ orientation }) =>
    orientation === "portrait" &&
    `
    font-size: calc(1.8 * var(--font-scaler));
    font-weight: 500;
    line-height: calc(1.8 * var(--font-scaler));
    padding-top: 8px;
  `}
`;

const MainTemperatureContainer = styled.div`
  display: flex;
  align-items: flex-end;
  gap: 4px;
  padding-bottom: 8px;

  ${({ orientation }) =>
    orientation === "portrait" &&
    `
    gap: 0;
  `}
`;

const MainTemperatureNumber = styled.span`
  color: ${({ themeMode }) =>
    getThemeColor("mainColor", themeMode)};
  font-size: 3.0rem;
  font-family: Poppins;
  font-weight: 500;
  line-height: 1.1;
  text-align: center;

  ${({ orientation }) =>
    orientation === "portrait" &&
    `
    font-size: calc(6.0 * var(--font-scaler));
    font-weight: 400;
    margin-right: 4px;
  `}
`;

const MainTemperatureUnit = styled.span`
  color: ${({ themeMode }) =>
    getThemeColor("mainColor", themeMode)};
  font-size: 1.4rem;
  font-family: Poppins;
  font-weight: 500;
  line-height: 1.1;
  text-align: center;

  ${({ orientation }) =>
    orientation === "portrait" &&
    `
    font-size: calc(4.5 * var(--font-scaler));
    font-weight: 300;
    line-height: calc(5.0 * var(--font-scaler));
  `}
`;

const MinMaxTemperatureContainer = styled.div`
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  justify-content: center;
  gap: 10px;
  min-width: 110px;
  height: 100%;

  ${({ orientation }) =>
    orientation === "portrait" &&
    `
    flex-direction: row;
    align-items: center;
    gap: 24px;
    min-width: auto;
  `}
`;

const MinMaxTemperature = styled.div`
  color: ${({ themeMode }) =>
    getThemeColor("mainColor", themeMode)};
  font-size: 2.8rem;
  font-family: Pretendard;
  font-weight: 600;
  white-space: nowrap;

  ${({ orientation }) =>
    orientation === "portrait" &&
    `
    font-size: calc(1.6 * var(--font-scaler));
    font-weight: 400;
    line-height: calc(1.6 * var(--font-scaler));
    padding-top: 8px;
  `}
`;

const WeatherDataItem = styled.div`
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: center;
  gap: 24px;
  width: 120px;
  min-height: 120px;
  max-height: 120px;
  padding: 8px 0;
  box-sizing: border-box;

  ${({ orientation }) =>
    orientation === "portrait" &&
    `
    gap: 12px;
    padding: 0;
    width: auto;
    min-height: auto;
    max-height: auto;
    flex-direction: row;
  `}
`;

const WeatherDataIconContainer = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 6px;

  ${({ orientation }) =>
    orientation === "portrait" &&
    `
    flex-direction: row;
    gap: 12px;
  `}
`;

const WeatherDataValueContainer = styled.div`
  display: flex;
  align-items: flex-end;
  gap: 4px;

  ${({ orientation }) =>
    orientation === "portrait" &&
    `
    gap: 8.64px;
  `}
`;

const WeatherIcon = styled.img`
  width: 48px;
  height: 48px;

  ${({ orientation }) =>
    orientation === "portrait" &&
    `
    width: 64px;
    height: 64px;
  `}
`;

const WeatherIconContainer = styled.div`
  width: 48px;
  height: 48px;
  position: relative;
  overflow: hidden;
  display: flex;
  align-items: center;
  justify-content: center;

  > * {
    width: 100% !important;
    height: 100% !important;
    object-fit: contain;
  }

  ${({ orientation }) =>
    orientation === "portrait" &&
    `
    width: 56px;
    height: 56px;
  `}
`;

const WeatherLabel = styled.div`
  color: ${({ themeMode }) =>
    getThemeColor(
      "WeatherLabelColor",
      themeMode
    )};
  font-size: calc(1.2 * var(--font-scaler));
  font-family: Pretendard;
  font-weight: 500;
  line-height: 1.2;
  white-space: nowrap;

  ${({ orientation }) =>
    orientation === "portrait" &&
    `
    font-size: calc(1.8 * var(--font-scaler));
    font-weight: 300;
    line-height: calc(1.8 * var(--font-scaler));
  `}
`;

const WeatherValueNumber = styled.span`
  color: ${({ themeMode }) =>
    getThemeColor("mainColor", themeMode)};
  font-size: calc(2.0 * var(--font-scaler));
  font-family: Poppins;
  font-weight: 400;
  line-height: 1.2;

  ${({ orientation }) =>
    orientation === "portrait" &&
    `
    font-size: calc(2.0 * var(--font-scaler));
    font-weight: 400;
    line-height: calc(2.0 * var(--font-scaler));
  `}
`;

const WeatherValueUnit = styled.span`
  color: ${({ themeMode }) =>
    getThemeColor("mainColor", themeMode)};
  font-size: calc(1.1 * var(--font-scaler));
  font-family: Poppins;
  font-weight: 500;
  line-height: 1.2;

  ${({ orientation }) =>
    orientation === "portrait" &&
    `
    font-size: calc(1.6 * var(--font-scaler));
    font-weight: 500;
    line-height: calc(1.6 * var(--font-scaler));
  `}
`;

const VerticalDivider = styled.div`
  width: 2px;
  height: 32px;
  opacity: 0.35;
  background: ${({ themeMode }) => getThemeColor("mainColor", themeMode)};
  flex-shrink: 0; 
`;

const VerticalDivider2 = styled.div`
  width: 2px;
  height: 22px;
  opacity: 0.35;
  background: ${({ themeMode }) => getThemeColor("mainColor", themeMode)};
  flex-shrink: 0;
`;